const DENIED_REASONS = {
    PAGE_PERMISSION_NOT_GRANTED: {
        title: '没有权限打开这个页面',
        description: '点击“申请访问权限”，授权人处理后即可打开。',
    },
    PAGE_NOT_REGISTERED: {
        title: '没有权限打开这个页面',
        description: '点击“申请访问权限”，授权人处理后即可打开。',
    },
    PAGE_CATALOG_UNSYNCED: {
        title: '没有权限打开这个页面',
        description: '点击“申请访问权限”，授权人处理后即可打开。',
    },
    PARTNER_ACCESS_NOT_CONFIGURED: {
        title: '没有权限打开这个页面',
        description: '点击“申请访问权限”，授权人处理后即可打开。',
    },
}

const DEFAULT_DENIED_REASON = {
    title: '没有权限打开这个页面',
    description: '点击“申请访问权限”，授权人处理后即可打开。',
}

export const getDeniedReasonContent = reason => DENIED_REASONS[reason] || DEFAULT_DENIED_REASON

const ROUTE_SETUP_REASONS = new Set(['PAGE_NOT_REGISTERED', 'PAGE_CATALOG_UNSYNCED'])

export const getDeniedReasonAction = reason => ROUTE_SETUP_REASONS.has(reason)
    ? {
        requestLabel: '申请访问权限',
        submittedLabel: '申请已发送',
        requestHint: '提交申请，通知授权人处理',
        guideTitle: '接下来怎么做',
        steps: ['点击“申请访问权限”，通知授权人。', '授权人处理后，点击“重新打开页面”。'],
    }
    : {
        requestLabel: '申请访问权限',
        submittedLabel: '申请已发送',
        requestHint: '提交申请，通知授权人处理',
        guideTitle: '接下来怎么做',
        steps: ['点击“申请访问权限”，通知授权人。', '授权人处理后，点击“重新打开页面”。'],
    }

export { buildAccessRequestText } from './vibeOwnerAccessStatus'
